import React from 'react';
import styled from 'styled-components';

const VERSION = process.env.VERSION;

const VersionNumDiv =  styled.div`
    margin-right: 6px;
    font-size: 11px;
    text-align: right;
`;

class VersionNum extends React.Component {
    render() {
        const color = this.props.color || '#373737';
        return VERSION ? (
            <VersionNumDiv style={{ color }}>v{VERSION}</VersionNumDiv>
        ) : null;
    }
}

export default VersionNum;


// WEBPACK FOOTER //
// ./src/components/VersionNum.js